import { GroupDetailPageLayout } from '@/components/admin/groups/GroupDetailPageLayout';
import { OptedOutMembers } from '@/components/group-form/OptedOutMembers';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

const Page: React.FC = () => {
  return (
    <GroupDetailPageLayout>
      <OptedOutMembers />
    </GroupDetailPageLayout>
  );
};

export default restrictedRoute(Page, {
  requiresEvery: [RouteRestrictions.ADMIN_ROLE],
});


